module.exports = __webpack_public_path__ + "static/itil-c5cf729be965677aeb3f555ffc4cf7c6.png";